import { useEffect, useState } from 'react'
import { Alert, Box, Button, IconButton, List, ListItem, ListItemText, Paper, TextField, Typography } from '@mui/material'
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import { observer } from 'mobx-react-lite'
import requestSourceStore from '../../../stores/requestSourceStore'

function RequestSources() {
  const [name, setName] = useState('')
  const [editingId, setEditingId] = useState(null)
  const [error, setError] = useState('')
  const mayManage = requestSourceStore.canManageDictionaries

  useEffect(() => { requestSourceStore.fetchSources().catch(() => setError('Не удалось загрузить источники')) }, [])

  const save = async () => {
    if (!name.trim()) return
    setError('')
    try {
      if (editingId) await requestSourceStore.updateSource(editingId, { name: name.trim() })
      else await requestSourceStore.createSource(name.trim())
      setName('')
      setEditingId(null)
    } catch (saveError) {
      setError(saveError.response?.data?.error || 'Не удалось сохранить источник')
    }
  }

  const remove = async id => {
    setError('')
    try {
      await requestSourceStore.deleteSource(id)
    } catch (deleteError) {
      setError(deleteError.response?.data?.error || 'Не удалось архивировать источник')
    }
  }

  return (
    <Paper sx={{ p: 2, m: 2, maxWidth: 720 }}>
      <Typography variant="h6">Источники заявок</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>Например: сайт, рекомендация, звонок или реклама.</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {mayManage && <Box sx={{ display: 'flex', gap: 1 }}>
        <TextField size="small" fullWidth label="Название источника" value={name} onChange={event => setName(event.target.value)} inputProps={{ maxLength: 100 }} />
        <Button variant="contained" disabled={!name.trim()} onClick={save}>{editingId ? 'Сохранить' : 'Добавить'}</Button>
      </Box>}
      <List dense>
        {requestSourceStore.sources.map(source => (
          <ListItem key={source.id} secondaryAction={mayManage ? (
            <Box>
              <IconButton aria-label="Изменить" onClick={() => { setEditingId(source.id); setName(source.name) }}><EditOutlinedIcon /></IconButton>
              <IconButton aria-label="Архивировать" onClick={() => remove(source.id)}><ArchiveOutlinedIcon /></IconButton>
            </Box>
          ) : null}>
            <ListItemText primary={source.name} />
          </ListItem>
        ))}
      </List>
    </Paper>
  )
}

export default observer(RequestSources)
